import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";
import "./notification.css";

const NotificationContext = createContext(null);

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback(
    (message, type = "info", title = null) => {
      setNotification({ message, type, title });

      const timeout = setTimeout(() => setNotification(null), 3000);
      return () => clearTimeout(timeout);
    },
    []
  );

  const hideNotification = () => setNotification(null);

  const defaultTitle = (type) => {
    if (notification?.title) return notification.title;
    switch (type) {
      case "success":
        return "Success";
      case "error":
        return "Error";
      case "warning":
        return "Warning";
      default:
        return "Notification";
    }
  };

  return (
    <NotificationContext.Provider value={{ showNotification, hideNotification }}>
      {children}

      {notification && (
        <div className={`notif notif--${notification.type}`}>
          <div className="notif__icon">
            {notification.type === "success" && "✓"}
            {notification.type === "error" && "✕"}
            {notification.type === "warning" && "!"}
            {notification.type === "info" && "?"}
          </div>

          <div className="notif__body">
            <div className="notif__title">
              {defaultTitle(notification.type)}
            </div>
            <div className="notif__message">{notification.message}</div>
          </div>

          <button className="notif__close" onClick={hideNotification}>
            ✕
          </button>
        </div>
      )}
    </NotificationContext.Provider>
  );
};
